import { DecimalPipe, formatNumber, getCurrencySymbol, NgClass } from '@angular/common';
import { Component, computed, ElementRef, HostBinding, inject, input, Renderer2 } from '@angular/core';
import { RoundService, ValueLike } from '../round.service';

@Component({
  selector: 'app-round-currency-pretty',
  imports: [NgClass, DecimalPipe],
  templateUrl: './round-currency-pretty.component.html',
  styleUrl: '../round.css'
})
export class RoundCurrencyPrettyComponent {

  number = input.required<ValueLike>()
  currencyCode = input<string>()
  locale = input<string>('en')
  sign = input(false)
  nullValue = input('')
  showZeroCents = input(false)
  showTitle = input(true)
  titleFormat = input('1.0-5')

  approxSymbolClass = input<string>()
  valueClass = input<string>()
  signSymbolClass = input<string>()
  currencySymbolClass = input<string>()
  intValueClass = input<string>()
  centValueClass = input<string>()
  posClass = input<string>()
  negClass = input<string>()

  private _prevPosClass?: string
  private _prevNegClass?: string

  private prevPosClass = computed(() => {
    const prev = this._prevPosClass
    this._prevPosClass = this.posClass()
    return prev
  })

  private prevNegClass = computed(() => {
    const prev = this._prevNegClass
    this._prevNegClass = this.negClass()
    return prev
  })

  protected value = computed(() => this.rs.transformToNumber(this.number()))
  private valueFixed = computed(() => {
    if (this.prevPosClass()) this.renderer.removeClass(this.element.nativeElement, this.prevPosClass()!)
    if (this.prevNegClass()) this.renderer.removeClass(this.element.nativeElement, this.prevNegClass()!)
    if (this.negClass()) this.renderer.removeClass(this.element.nativeElement, this.negClass()!)
    if (this.posClass()) this.renderer.removeClass(this.element.nativeElement, this.posClass()!)

    if (this.value() === null) return 0

    if (this.value()! > 0 && this.posClass()) {
      this.renderer.addClass(this.element.nativeElement, this.posClass()!)
    }
    if (this.value()! < 0 && this.negClass()) {
      this.renderer.addClass(this.element.nativeElement, this.negClass()!)
    }
    return this.value()!
  })
  protected valueApprox = computed(() => Math.abs(this.rs.getApproxValue(this.valueFixed())))
  protected signSymbol = computed(() => this.rs.getSignSymbol(this.valueFixed(), this.sign()))
  protected approxSymbol = computed(() => this.rs.getApproxSymbol(this.valueFixed()))
  protected currencySymbol = computed(() => this.currencyCode() ? getCurrencySymbol(this.currencyCode()!, 'narrow', this.locale()) : '')
  protected format = computed(() => this.rs.getCurrencyFormat(this.valueApprox()))
  protected dot = computed(() => formatNumber(1.1, this.locale(), '1.1-1').charAt(1))

  protected int = computed(() => Math.floor(Math.abs(this.valueApprox())) + (this.rs.getCents(this.valueApprox()) == 100 ? 1 : 0))
  protected cent = computed(() => {
    const cent = this.rs.getCents(this.valueApprox())
    if (cent == 0 || cent == 100) return this.showZeroCents() ? '00' : ''
    return cent.toString().padStart(2, '0')
  })

  private titleSignal = computed(() => {
    if (this.value() === null) return undefined
    return this.showTitle() ? formatNumber(this.valueFixed(), this.locale(), this.titleFormat()) : undefined
  })

  @HostBinding('attr.title')
  protected get titleAttr() {
    return this.titleSignal()
  }

  private rs = inject(RoundService)
  private element = inject(ElementRef<HTMLElement>)
  private renderer = inject(Renderer2)
}
